import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { USERS } from '../config/usersConfig'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user:  null,
      isLoading: false,
      error: null,

      login: async (email, password) => {
        set({ isLoading: true, error: null })
        await new Promise(r => setTimeout(r, 400))

        // Lookup in usersConfig.js
        const found = USERS.find(
          u => u.email === email.trim() && u.password === password
        )

        if (!found) {
          set({ error: 'Email ou mot de passe incorrect', isLoading: false })
          return
        }

        set({
          token: `ems-token-${found.email}-${Date.now()}`,
          user:  { name: found.name, initials: found.initials, email: found.email, role: found.role },
          isLoading: false,
          error: null,
        })

        /* TODO — Replace with real FastAPI call:
        try {
          const res = await fetch('/api/auth/token', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ username: email, password }),
          })
          if (!res.ok) throw new Error('Invalid credentials')
          const data = await res.json()
          set({ token: data.access_token, user: data.user, isLoading: false })
        } catch (err) {
          set({ error: err.message, isLoading: false })
        }
        */
      },

      logout: () => set({ token: null, user: null }),

      getHeaders: () => ({
        Authorization: `Bearer ${get().token}`,
        'Content-Type': 'application/json',
      }),
    }),
    {
      name: 'ems-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
)
